var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span ng-show=\"$eventDateListCtrl.isMultiDay\">\n<b>Please select from available dates: </b>\n<select ng-model=\"$eventDateListCtrl.selectedEvent\" ng-change=\"$eventDateListCtrl.update()\">\n<option ng-repeat=\"event in $eventDateListCtrl.tempAllEvents\" value=\"{{event.id}}\">{{event.datetime | datetime: 'Do MMMM YYYY HH:mm'}}</option>\n</select>\n</span>\n";
var id1="javascripts/event-date-picker/event_date_list.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/event-date-picker/event_date_list.template.html
// module id = 1312
// module chunks = 0